<!--<script src="../../assets/js/blue-canvas-tmpl-config/sign-config.js"></script>-->
<template>

    <bv-home-view class='wap' :router-level='2' style="background:#f8f8f8;">

        <div class="" style="background:#71BCDC;">
            <!--banner-->
            <div class="bc-row bc-ps-f bc-flex bc-flex-ai-c bc-pd-l-16rp bc-pd-tb-9rp get-search" ref="getSearch" style="top:0;z-index:300;"
                :style="`background: url(${config.path.static}/img/home/home/search-img.png) 0% 0% / 100% 100% no-repeat;`">
                <a href="javascript:;" @click="backBtn()">
                  <span class="bc-arrow bc-arrow-white bc-arrow-big bc-arrow-l"></span>
                </a>
                <div class="bc-flex-10 bc-pd-l-10rp">
                    <!--搜索-->
                    <div class="bc-v-m">
                        <router-link to="/search">
                            <div class="bc-bg-white bc-bd-radius-20 bc-pd-tb-7rp bc-bd-white">
                                <img class="bc-mg-l-18rp bc-mg-r-10rp" width="19" height="18" :src="`${config.path.static}/img/home/home/search.png`" alt="">
                                <span class="bc-f-16rp" style="color:#ccc;">如何才能获得财富</span>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="bc-t-c bc-t-white bc-t-r">
                    <!--签到-->
                    <div class="bc-inline-block bc-t-c bc-pd-l-12rp" :class="config.device.isApp ? 'bc-pd-r-12rp' : 'bc-pd-r-16rp'" ref="xingfu_sign" @click.stop="toSign">
                        <img class="" width="19" height="18" :src="`${config.path.static}/img/home/home/sign.png`" alt="">
                        <div class="bc-f-10rp">签到</div>
                    </div>
                    <!--分享-->
                    <template v-if="userInfo.phone">
                        <!--登录了-->
                        <div class="bc-inline-block bc-t-c bc-pd-lr-12rp" v-if="config.device.isApp" @click="$share({
                        title: mainData.share_title,
                        descr: mainData.share_content,
                        thumImage: `${config.path.base}${mainData.share_img}`
                       })">
                            <i class="icon fenxiang1 bc-f-18rp"></i>
                            <div class="bc-f-10rp">分享</div>
                        </div>
                    </template>
                    <template v-else>
                        <!--去登录-->
                        <div class="bc-inline-block bc-t-c bc-pd-lr-12rp" v-if="config.device.isApp" @click="share()">
                            <i class="icon fenxiang1 bc-f-18rp"></i>
                            <div class="bc-f-10rp">分享</div>
                        </div>
                    </template>
                </div>
            </div>
            <!--banner-->
            <div class="bc-row bc-ps-r" :style="{'margin-top':searchHeight + 'px'}" v-if="bannerImg">
                <div class="bc-block">
                    <img class="bc-w-100 bc-block" ref="banner_Img" :src="bannerImg[0].src_img" alt="慧联天下综合服务平台">
                </div>

                <div class="bc-row bc-pd-lr-5rp bc-t-white bc-ps-a" style="bottom:2rem;z-index:200;">
                    <div class="bc-flex bc-flex-jc-c bc-flex-ai-c bc-pd-tb-8rp number-grow" style="">
                        <img class="left-img bc-mg-r-4rp" :src="`${config.path.static}/img/home/home/left.png`" alt="">
                        <div class="bc-flex bc-t-c">
                            <WNumberGrow :value="countNum"></WNumberGrow>
                        </div>
                        <img class="right-img" :src="`${config.path.static}/img/home/home/right.png`" alt="">
                    </div>
                </div>
            </div>
        </div>

        <!--一点百通系列-->
        <div class="bc-pd-t-20rp bc-bg-white content-wrap" ref="contentWrap">
            <div class="bc-row" :class="'classify' + indexs" v-for="(item,indexs) in contentData" :key="item.id" v-if="!formMeber || (formMeber && item.name == '生命驾照普及工程')">
                <div class="item" :class="item.color ? 'bc-pd-b-10rp' : ''" :style="{'box-shadow':'0 4px 11px 0 rgba(' + item.color + '0.4)'}">

                    <div v-for="(second,ind) in item.son" :key="ind">
                        <div class="bc-row">
                            <img :src="second.src_img" :alt="second.id" class="bc-w-100 bc-block" v-if="second.cat_type === 2 && second.dian_home === 1" @click="$toast('敬请期待')">
                            <template v-else>
                                <img :src="second.src_img" :alt="second.id" class="bc-w-100 bc-block" @click="linkUlr(second.url,'1')">
                            </template>
                        </div>

                        <div class="bc-row bc-pd-lr-8rp" :class="{'item sole bc-pd-b-10rp' : second.name === '五官专区'}">
                            <!--<div class="bc-pd-tb-12rp" :class="second.son.length % 2 != 0 && index == 0 ? 'bc-col-xs-12 bc-pd-lr-16rp' : 'bc-col-xs-6 bc-pd-lr-8rp'" :key="index" v-for="(third,index) in second.son">-->
                            <div class="bc-pd-tb-12rp" :class="setClass(second.son,index,third)" :key="index" v-for="(third,index) in second.son">
                                <div :class="second.son.length % 2 != 0 && index == 0 ? 'addNumber' : ''">
                                    <img :src="third.src_img" :alt="third.name" class="bc-w-100 bc-block" v-if="third.dian_home === 1" @click="$toast('敬请期待')">
                                    <template v-else>
                                        <img :src="third.src_img" :alt="third.name" class="bc-w-100 bc-block" @click="linkUlr(third.url,'1')">
                                    </template>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!--页脚-->
        <!--other 插槽-->
        <template slot="other" slot-scope="scope">
            <div v-show="fixSearchShadow" class="bc-row bc-ps-f bc-flex bc-flex-ai-c bc-pd-l-16rp bc-pd-tb-9rp bc-bg-white fix-search" ref="getFixSearch" style="top:0;z-index:300;">
                <a href="javascript:;" @click="backBtn()">
                    <span class="bc-arrow bc-arrow-999 bc-arrow-big bc-arrow-l"></span>
                </a>
                <div class="bc-flex-10 bc-pd-l-10rp">
                    <!--搜索-->
                    <div class="bc-v-m">
                        <router-link to="/search">
                            <div class="bc-bd-radius-20 bc-pd-tb-7rp" style="border:1px solid #ccc;">
                                <img class="bc-mg-l-18rp bc-mg-r-10rp" width="19" height="18" :src="`${config.path.static}/img/home/home/search.png`" alt="">
                                <span class="bc-f-16rp" style="color:#ccc;">如何才能获得财富</span>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="bc-t-c bc-t-r bc-t-999">
                    <!--签到-->
                    <div class="bc-inline-block bc-t-c bc-pd-l-12rp" :class="config.device.isApp ? 'bc-pd-r-12rp' : 'bc-pd-r-16rp'" ref="xingfu_sign" @click.stop="toSign">
                        <img class="" width="19" height="18" :src="`${config.path.static}/img/home/home/sign-fix.png`" alt="">
                        <div class="bc-f-10rp">签到</div>
                    </div>
                    <!--分享-->
                    <template v-if="userInfo.phone">
                        <!--登录了-->
                        <div class="bc-inline-block appshare bc-t-c bc-pd-lr-12rp" v-if="config.device.isApp" @click="$share({
                              title: mainData.share_title,
                              descr: mainData.share_content,
                              thumImage: `${config.path.base}${mainData.share_img}`
                          })">
                            <i class="icon fenxiang1 bc-f-18rp bc-t-999"></i>
                            <div class="bc-f-10rp">分享</div>
                        </div>
                    </template>
                    <template v-else>
                        <!--去登录-->
                        <div class="bc-inline-block bc-t-c bc-pd-lr-12rp" v-if="config.device.isApp" @click="share()">
                            <i class="icon fenxiang1 bc-f-18rp bc-t-999"></i>
                            <div class="bc-f-10rp">分享</div>
                        </div>
                    </template>
                </div>
            </div>
            <!--吸顶-->
            <template v-if="!(isIpad && isIOShide)">
              <div :style="{'visibility':scope.scroll.top > contentTop ? '' : 'hidden','top' : searchHeight + 'px'}" class="bc-ps-f bc-row bc-flex bc-flex-jc-sb fixed-list" v-if="!formMeber" ref="getFixed">
                  <span class="bc-inline-block bc-pd-tb-13rp bc-pd-lr-7rp bc-f-16rp" :class="{'active' : activeIndex === index}" v-for="(item,index) in navList" @click="jump(index)" :key="index">{{item.name}}</span>
              </div>
            </template>
            <!-- 绑定手机号 -->
            <bv-bind-phone :show-bind-phone-status="showBindPhoneStatus" @close-bind-phone="closeBindPhone" />
            <!--没有绑定手机号分享弹窗-->
            <bv-bind-phone-share @close-bind-phone="closeBindPhoneShare" />
        </template>
    </bv-home-view>
</template>

<script>
import router from '@router';
import { keepScroll } from '$assets/js/keep-alive-scroll.js';
import { scrollMixin, scrollEndHook, scrollNoHasListData } from '$scroll';
import { login } from '$assets/js/login';
import { docTitle } from '$assets/js/document';
import programUrl from '@config/program-url';
import WNumberGrow from '@components/wap/home/w-number-grow.vue';
var throttle = require('lodash/throttle');
import { unLogin } from '$assets/js/login';
import store from '@store';

export default {
    name: "home",
    mixins: [scrollMixin(), keepScroll()],
    data () {
      return {
            isIOShide: window.isIOShide,
            isIpad: window.browser.versions.iPad,
            contentData: [],
            navList: [
                { name: "健康" },
                { name: "财富" },
                { name: "育子" },
                { name: "婚姻" },
                { name: "心灵" }
            ],
            activeIndex: 0,
            fixSearchShadow: false,
            topHeight: [0, 0, 0, 0, 0, 0],
            contentTop: "",//悬浮吸顶的距离
            searchHeight: "",
            fixedHeight: "",
            bannerImg: '',
            rests: '',
            programUrl: programUrl,
            mainData: {},
            isLoad: false,
            countNum: "",
            //绑定手机的状态
            showBindPhoneStatus: (() => {
                return router.currentRoute.fullPath === '/';
            })(),
            nowData: '',
            intervalFunction: null,
            clock: true,
            condition: true,
            formMeber:this.$route.query.from,//个人中心 跳转过来... 显示生命驾校普及工程
        }
    },
    components: {
        WNumberGrow,
    },
    methods: {
        backBtn() {
            // console.log(this.$router,'111')
            if (window.history.length > 1) history.back();
            else location.href = `${programUrl["gou-wu-bao"]}`;
        },
        //一点通标题  改前两个字颜色
        changeColor: function (name, fontColor) {
            if (name && name.length > 0) {
                const leftName = name.slice(0, 2);
                const rightName = name.slice(2);
                name = '<span class="bc-pd-r-5rp" style="color:rgba(' + fontColor + ',1)">' + leftName + '</span>' + '<span>' + rightName + '</span>'
            }
            return name;
        },

        linkUlr (url, type) {
            if (type === '1') {
                url = url.replace(/amp\;/g, '');
                if (url.indexOf('disease') != -1) {  //点通系列加上来自一点百通的标识
                    this.$router.push({ path: `/${url}&lifets=1` });
                } else {
                    this.$router.push({ path: `/${url}` });
                }
            }
        },
        //没有绑定手机号分享
        closeBindPhoneShare () {
            store.state.shareState = false;
        },
        // 显示banner
        showBanner () {
            this.$axios.get('/api/banner/index',).then((res) => {
                this.mainData = res.data.data;
                this.bannerImg = this.mainData.banner;

                this.countNum = this.mainData.count;

                // 网页标题
                docTitle(this.mainData.share_title);
                // 微信分享
                this.$weChatShare({
                    title: this.mainData.share_title,
                    desc: this.mainData.share_content,
                    imgUrl: `${this.config.path.base}${this.mainData.share_img}`
                });

            })
        },
        //动态设置class
        setClass(son,index,third){
          let str = '';
          if(third.dian_home === 1){
            if(son.length % 2 != 0 && index == 0){
              str = 'bc-col-xs-12 bc-pd-lr-16rp prompt';
            }else{
              str = 'bc-col-xs-6 bc-pd-lr-8rp prompt';
            }
          }else{
            if(son.length % 2 != 0 && index == 0){
              str = 'bc-col-xs-12 bc-pd-lr-16rp';
            }else{
              str = 'bc-col-xs-6 bc-pd-lr-8rp';
            }
          }
          return str;
        },
        //ipad移除尽请期待
        removeItem(){
          setTimeout(()=>{
            let itemLiat = document.querySelectorAll(".prompt");
            itemLiat.forEach((item)=>{
              item.remove();
            })
          })
        },
        initData () {
            this.$axios.post('/api/Category/categroy_index').then((res) => {
                this.contentData = res.data.data;
            });
        },
        iPadData () {
            this.$axios.post('/api/Category/categroy_index').then((res) => {
              for (let i = 0; i < res.data.data.length - 1; i++) {
                if (this.isIOShide) {
                  if (res.data.data[i].keywords == "消费") { //  || res.data.data[i].keywords == "财富"
                    this.contentData.push(res.data.data[i]);
                  }
                }
                else this.contentData.push(res.data.data[i]);
              }
              // this.removeItem();
            });
        },
        scrollCont () {
            let that = this;
            document.querySelectorAll('.bv-view-scroll')[2].addEventListener('scroll', function () {
                that.a(this);
            })
        },
      a: throttle(function (_this) {
        try {
            // debugger
            var that = this;
            if (_this.scrollTop > that.searchHeight) {
                that.fixSearchShadow = true;
            } else {
                that.fixSearchShadow = false;
            }
            if (!that.clock) return;
            this.topHeight[0] = document.querySelector('.classify0').offsetTop;
            this.topHeight[1] = document.querySelector('.classify1').offsetTop;
            this.topHeight[2] = document.querySelector('.classify2').offsetTop;
            this.topHeight[3] = document.querySelector('.classify3').offsetTop;
            this.topHeight[4] = document.querySelector('.classify4').offsetTop;
            this.topHeight[5] = document.querySelector('.classify5').offsetTop;

            if (_this.scrollTop > that.topHeight[5] - (that.searchHeight + that.fixedHeight)) {
                that.activeIndex = 5;
            } else if (_this.scrollTop > that.topHeight[4] - (that.searchHeight + that.fixedHeight)) {
                that.activeIndex = 4;
            } else if (_this.scrollTop > that.topHeight[3] - (that.searchHeight + that.fixedHeight)) {
                that.activeIndex = 3;
            } else if (_this.scrollTop > that.topHeight[2] - (that.searchHeight + that.fixedHeight)) {
                that.activeIndex = 2;
            } else if (_this.scrollTop > that.topHeight[1] - (that.searchHeight + that.fixedHeight)) {
                that.activeIndex = 1;
            } else {
                that.activeIndex = 0;
            }
          } catch (e) { }
        }, 50),

        // 判断登录
        // isLogin() {
        // 	if (this.$store.getters.isLogin) {
        // 		return true;
        // 	} else {
        // 		login();
        // 		return false;
        // 	}
        // },
        closeBindPhone () {
            this.showBindPhoneStatus = false;
        },
        // 签到
        toSign () {
            const ua = navigator.userAgent.toLowerCase();
            const ios = ua.match(/cpu iphone os (.*?) like mac os/);

            /*app ——> 去登录  微信绑定手机号*/
            if (!this.userInfo.phone) {
                if (this.config.device.isApp) {
                    unLogin();
                    return;
                } else {
                    this.showBindPhoneStatus = true;
                }
            } else {
                this.$router.push('/sign');
            }
        },
        share () {
            const ua = navigator.userAgent.toLowerCase();
            const ios = ua.match(/cpu iphone os (.*?) like mac os/);
            /*app ——> 去登录  微信绑定手机号*/
            if (this.config.device.isApp) {
                unLogin();
                return;
            } else {
                this.showBindPhoneStatus = true;
            }
        },
        //点击跳转
        jump (index) {
            this.clock = false;
            this.activeIndex = index;
            document.querySelectorAll('.bv-view-scroll')[2].scrollTo({
                top: this.topHeight[index] - (this.searchHeight + this.fixedHeight),
                behavior: "instant"
            });
            setTimeout(() => {
                this.clock = true;
            }, 100);
        }
    },
  mounted () {
      // console.log({...this.$router},'852')
        if (this.isIpad) {
            this.iPadData();
            // console.log("是iPad");
        } else {
            this.initData();
        }
        this.showBanner(); //顶部banner
    },
    activated () {
        // 微信分享,因为做了缓存，当从其他页面过来是其他页面的分享信息了，所以要重置一次
        if (this.mainData) {
            this.$weChatShare({
                title: this.mainData.share_title,
                desc: this.mainData.share_content,
                imgUrl: `${this.config.path.base}${this.mainData.share_img}`
            });
        }
    },
    computed: {
        userInfo () {
            return this.$store.state.userInfo;
        }
    },
    updated () {
        if (this.condition) {
            setTimeout(() => {
                let content = document.querySelector('.content-wrap');
                this.contentTop = content.offsetTop;

                this.searchHeight = this.$refs.getSearch.offsetHeight;
                if (this.$refs.getFixed) this.fixedHeight = this.$refs.getFixed.offsetHeight || 0;
                else this.fixedHeight = 0
                // this.fixedSearchHeight = this.$refs.getFixSearch.offsetHeight;

            }, 500);
            this.scrollCont();

            this.condition = false;
        }
    }
}
</script>

<style scoped lang="scss">
.number-grow {
    border: 2px solid rgba(255, 255, 255, 1);
    border: {
        bottom: none;
        top-left-radius: 7px;
        top-right-radius: 7px;
    }
    background: #80c4e1;
}

.scroll-x {
    .scroll_active {
        color: #509bbb;
        .active {
            border-bottom: 2px solid #509bbb;
        }
    }
}

.addNumber {
    margin: 0 auto;
    width: 50%;
}

.left-img {
    width: 27px;
    height: 13px;
}
.right-img {
    width: 120px;
    height: 13px;
}
.sole {
    box-shadow: 1px 4px 10px 0 rgba(255, 164, 110, 0.4);
}
.item {
    border-radius: 0 0 8px 8px;
    margin-bottom: 25px;
}
.get-search {
    max-width: 1024px;
}
.fix-search {
    max-width: 1024px;
    margin: 0 auto;
}

.fixed-list {
    max-width: 1024px;
    margin: 0 auto;
    z-index: 290;
    background: #fff;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    color: #333;
    span {
        &.active {
            color: #71bcdc;
            position: relative;
            &:after {
                content: "";
                display: inline-block;
                width: 50%;
                height: 3px;
                background: #71bcdc;
                position: absolute;
                bottom: 0;
                left: 25%;
                border-radius: 10px;
            }
        }
    }
}
</style>
